export default "__VITE_ASSET__CuCl4I12__"